export default __webpack_public_path__ + "static/media/fail.da91a772.gif";